import * as React from "react";

import existingPage from "@/features/funnel/assets/existing-page.png";
import newPage from "@/features/funnel/assets/new-page.png";
import Popover from "@replo/design-system/components/popover/Popover";
import { Card } from "@replo/design-system/components/shadcn/core/card";
import twMerge from "@replo/design-system/utils/twMerge";

interface AddPageSelectionCardProps {
  image: string;
  title: string;
  onClick?: () => void;
}

function AddPageSelectionCard({
  image,
  title,
  onClick,
}: AddPageSelectionCardProps) {
  return (
    <Card
      className={twMerge(
        "p-3 cursor-pointer transition-all duration-200",
        "hover:bg-sheet hover:border-primary flex flex-col items-center text-center gap-2 shadow-none",
      )}
      onClick={onClick}
    >
      <div className="rounded-lg flex items-center justify-center h-13">
        <img src={image} className="object-contain h-full" alt={title} />
      </div>
      <div className="text-base text-default">{title}</div>
    </Card>
  );
}

interface AddPageSelectionPopoverProps {
  onSelectExistingPage?: () => void;
  onSelectNewPage?: () => void;
  isOpen?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
}

export default function AddPageSelectionPopover({
  children,
  onSelectExistingPage,
  onSelectNewPage,
  isOpen,
  onOpenChange,
}: React.PropsWithChildren<AddPageSelectionPopoverProps>) {
  return (
    <Popover
      className="w-[260px]"
      isOpen={isOpen}
      onOpenChange={onOpenChange}
      content={
        <div className="flex flex-col gap-3 w-full">
          <AddPageSelectionCard
            image={existingPage}
            title="Existing Page"
            onClick={onSelectExistingPage}
          />
          <AddPageSelectionCard
            image={newPage}
            title="New Page"
            onClick={onSelectNewPage}
          />
        </div>
      }
      shouldPreventDefaultOnInteractOutside={true}
      hideCloseButton={true}
      side="bottom"
      sideOffset={8}
      triggerAsChild={true}
    >
      {children}
    </Popover>
  );
}
